import { useQueryClient } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import { Rules } from "../interfaces/TableRow";

export function useGetPlanoOperacionalRef() {
  const qc = useQueryClient();

  const fetchRef = async (idArg: string): Promise<Rules> => {
    const { data } = await http.get(
      URL.PLANO_OPERACIONAL.OBTER_REFERENCIA_BY_ID(idArg),
      {}
    );

    qc.setQueryData([URL.PLANO_OPERACIONAL.OBTER_REFERENCIA_BY_ID, idArg], data);
    return data;
  };

  return { fetchRef };
}

export function useGetAllPlanoOperacionalRef() {
  const qc = useQueryClient();

  const fetchAllRef = async (query: string): Promise<Rules[]> => {
    const { data } = await http.get(
      `${URL.PLANO_OPERACIONAL.OBTER_REFERENCIAS}${query}`,
      {}
    );

    qc.setQueryData([URL.PLANO_OPERACIONAL.OBTER_REFERENCIAS, query], data);
    return data;
  };

  return { fetchAllRef };
}